import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'moment-timezone';
import { TODO } from '@b2b/types/core';

export const OrdersCreateControllerModule = angular
  .module('acme.view.application.orders.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.calendar',
    'acme.common.service.order',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
    'acme.common.service.auth',
    'acme.common.factory.notice',
    'acme.common.service.templates',
    'acme.common.filter.saleChannel',
    'acme.common.service.userPreferences',
    'acme.view.application.templates.showTemplatesModal.controllers',
  ])

  .controller('OrdersCreateController', [
    '$scope',
    '$state',
    '$filter',
    '$timeout',
    '$q',
    '$uibModal',
    'ApiService',
    'OrderService',
    'HelpersService',
    'CalendarService',
    'PermissionsService',
    'NoticeFactory',
    'TemplatesService',
    'UserPreferencesService',
    function (
      $scope,
      $state,
      $filter,
      $timeout,
      $q,
      $uibModal,
      ApiService,
      OrderService,
      HelpersService,
      CalendarService,
      PermissionsService,
      NoticeFactory,
      TemplatesService,
      UserPreferencesService
    ) {
      $scope.ordersCreate = {
        template: {
          name: '',
          startTime: new Date(),
          description: '',
          capacity: 0,
          duration: {
            hour: 1,
            minutes: 30,
          },
          type: 'private',
          priceLists: [],
          addOns: {},
          reviewState: 'published',
          schedules: [],
          ticketDetails: {
            ticketDurationDays: 1,
            expireFromEventDate: false,
          },
        },

        partner: {},
        customer: {},

        accountId: false,
        customerId: false,
        isSubmitted: false,
        isValidated: false,
        templateCreationInProgress: false,
        eventTemplateId: false,
        isCSR: false,
        showModal: false,

        eventDate: new Date(),
        eventStartHour: new Date(),
        noticeTimer: '',
        addOnQuantity: 0,
        quantity: 0,
        total: 0,
        events: [],

        event: {},
        notice: {},

        discounts: [],
        priceLists: [],
        eventTemplates: [],
        enableCSRToggle: null,
        currentTemplate: null,
        templateDiscount: null,
        templateDiscounts: null,
        discountedPriceList: null,
        discountedAddOns: null,
        selectedDiscount: null,
        selectedPriceList: null,
        selectedEventStartHour: null,
        selectedEventTemplate: {
          id: null,
          name: 'Custom event...',
        },
        colorCodes: angular.copy(TemplatesService.getColorCategory()),
        disableColor: true,
        eventBackgroundColor: '',

        spectrumConfig: {
          titleText: 'Tile color',
          color: TemplatesService.getColorCategory().backgroundColor,
        },
        dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
        hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

        ticketExpirationSetting: [
          {
            name: 'expireFromEventDate',
            label: 'event start',
          },
          {
            name: 'expireFromPurchaseDate',
            label: 'purchase',
          },
        ],

        ticketExpirationSelection: 'expireFromEventDate',

        hasOrganization: true,

        init: function () {
          this.isCSR = PermissionsService.check('CSR');

          if (!PermissionsService.check('ACCT_ORDERS_CREATE')) {
            $state.go('home.default', {}, { notify: true });
          }

          if (PermissionsService.check('CSR')) {
            this.enableCSRToggle = true;
          }

          $scope.$emit('Application::contentTitleChange', {
            title: 'Create Order',
            buttonLeft: {
              label: 'Cancel',
              action: function () {
                $scope.ordersCreate.cancel();
              },
            },
            buttonRight: {
              label: 'Checkout',
              action: function () {
                $scope.ordersCreate.complete();
              },
            },
          });

          $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);

          $scope.$watch('ordersCreate.eventDate', this.onTemplateDateChange);
          $scope.$watch('ordersCreate.selectedEventTemplate', this.onEventTemplateChange);
          $scope.$watch('ordersCreate.selectedEventStartHour', this.onEventStartHourChange);
          $scope.$watch('ordersCreate.selectedPriceList', this.onPriceListChange);
          $scope.$watch('ordersCreate.templateDiscounts', this.onTemplateDiscountsLoaded);
          $scope.$watch('ordersCreate.selectedDiscount', this.onSelectedDiscountUpdate);
          $scope.$watch('ordersCreate.colorCodes', this.onColorCodesUpdate);

          this.notice = new NoticeFactory();

          this.ticketExpirationSelection = this.ticketExpirationSetting[0];

          // Init start hour
          this.updateEventStartHour();

          this.resetSchedule();

          if ($state.params.eventTemplateId) {
            console.log('OrdersCreateController::init', $state.params.eventTemplateId);
            this.eventTemplateId = $state.params.eventTemplateId;
            this.getTemplate(this.eventTemplateId, true);
          }

          if ($state.params.accountId) {
            this.accountId = $state.params.accountId;
            this.getPartners(this.accountId);
          }

          if ($state.params.customerId) {
            this.customerId = $state.params.customerId;
            this.getCustomer(this.customerId);
          }

          if (!this.accountId && !this.customerId) {
            //Ideally this should never happen - we're in a weird state. Show an error that organization is required.
            this.notice.showErrorMessages([
              {
                message:
                  'You must choose an Organization before creating this order. Please try creating this order again.',
              },
            ]);
            this.hasOrganization = false;
          }

          this.getPriceLists();
          this.getDiscounts();
        },

        resetSchedule: function () {
          this.template.schedules = [
            {
              name: 'schedule_1',
              description: 'Schedule 1',
              effectiveStartTime: '',
              hours: [
                {
                  hour: 10,
                  minutes: 0,
                  quantity: 1,
                },
              ],
              days: [],
            },
          ];
        },

        setScheduleName: function () {
          var self = $scope.ordersCreate;
          self.template.schedules[0].name = self.partner.company.name;
          self.template.schedules[0].description = self.partner.company.name + ' schedule';
        },

        updateEventStartHour: function () {
          var startHour = new Date(this.eventDate);

          startHour.setHours(9);
          startHour.setMinutes(0);
          startHour.setSeconds(0);
          startHour.setMilliseconds(0);

          this.eventStartHour = startHour;
        },

        getEvent: function (id) {
          if (id) {
            ApiService.partners.reseller
              .event({ accountId: this.accountId, eventId: id })
              .then(this.success.getEvent, this.error.getEvent);
          }
        },

        getEvents: function (id) {
          var times;

          if (id) {
            if (this.eventDate instanceof Date) {
              times = this.getEventTimes();
              console.log('OrdersCreateController::getEventTimes', this.eventDate);

              if (this.accountId) {
                console.log('OrdersCreateController::getEventTimes', this.accountId);
                ApiService.partners.reseller
                  .events({
                    accountId: this.accountId,
                    templateId: id,
                    startTime: CalendarService.toISO8601(times.startTime),
                    endTime: CalendarService.toISO8601(times.endTime),
                    type: 'private',
                  })
                  .then(this.success.getEvents, this.error.getEvents);
              } else {
                ApiService.event
                  .schedules({
                    templateId: id,
                    startTime: CalendarService.toISO8601(times.startTime),
                    endTime: CalendarService.toISO8601(times.endTime),
                  })
                  .then(this.success.getEvents, this.error.getEvents);
              }
            }
          } else {
            this.resetEvents();
            this.selectedEventStartHour = null;
          }
        },

        getEventTimes: function () {
          var startTime, endTime;

          console.log('OrdersCreateController::getEventTimes', this.eventDate);
          if (this.eventDate instanceof Date) {
            startTime = new Date(this.eventDate);
            startTime.setHours(0);
            startTime.setMinutes(0);
            startTime.setSeconds(0);
            startTime.setMilliseconds(0);

            endTime = new Date(this.eventDate);
            endTime.setHours(23);
            endTime.setMinutes(59);
            endTime.setSeconds(59);
            endTime.setMilliseconds(999);
          }

          return {
            startTime: startTime,
            endTime: endTime,
          };
        },

        getEndTime: function (startTime, duration) {
          return moment(startTime).add(duration.hour, 'hours').add(duration.minutes, 'minutes').format();
        },

        getPartners: function (id) {
          if (id) {
            ApiService.partners.detail(id).then(this.success.getPartners, this.error.getPartners);
          }
        },

        getCustomer: function (id) {
          if (id) {
            ApiService.customers.detail({ customerId: id }).then(this.success.getCustomer, this.error.getCustomer);
          }
        },

        getPriceLists: function () {
          ApiService.price.lists
            .list(HelpersService.getPaginator())
            .then(this.success.getPriceLists, this.error.getPriceLists);
        },

        getDiscounts: function () {
          ApiService.discounts
            .list('v2', HelpersService.getPaginator())
            .then(this.success.getDiscounts, this.error.getDiscounts);
        },

        getTemplate: function (id, setSelected) {
          if (id) {
            if (setSelected) {
              ApiService.program.get(id).then(function (response) {
                var self = $scope.ordersCreate,
                  template = response.data.payload;

                self.selectedEventTemplate = {
                  id: template.id,
                  name: template.name,
                  type: template.type,
                  admissionType: template.admissionType,
                };

                self.success.getTemplate(response);
              }, this.error.getTemplate);
            } else {
              ApiService.program.get(id).then(this.success.getTemplate, this.error.getTemplate);
            }
          }
        },

        getTemplateDiscounts: function (id) {
          if (id) {
            ApiService.partners.templates
              .detail(id)
              .then(this.success.getTemplateDiscounts, this.error.getTemplateDiscounts);
          }
        },

        getDiscountedPriceList: function () {
          console.log('OrdersCreateController::getDiscountedPriceList', this.selectedDiscount, this.selectedPriceList);
          if (this.selectedDiscount && this.selectedPriceList) {
            console.log(
              'OrdersCreateController::getDiscountedPriceList',
              this.selectedDiscount.id,
              this.selectedPriceList.id
            );

            ApiService.discounts
              .preview({
                discountId: this.selectedDiscount.id,
                priceListId: this.selectedPriceList.id,
              })
              .then(this.success.getDiscountedPriceList, this.error.getDiscountedPriceList);
          }
        },

        getPartnerDescription: function (partner) {
          var h,
            r = '';

          if (partner) {
            if (partner.company) {
              h = 'Organization information \n';
              r += partner.company.name ? partner.company.name + '\n' : '';
              r += partner.company.streetAddress1 ? partner.company.streetAddress1 + '\n' : '';
              r += partner.company.streetAddress2 ? partner.company.streetAddress2 + '\n' : '';
              r += partner.company.city ? partner.company.city + ', ' : '';
              r += partner.company.state ? partner.company.state + '\n' : '';
              r += partner.company.zip ? partner.company.zip + '\n' : '';
              r += partner.company.country ? partner.company.country + '\n' : '';

              if (r.length > 0) {
                r = h + r + '\n';
              } else {
                r = h + 'No information available \n';
              }
            }

            if (partner.primaryContact) {
              r += 'Primary contact information \n';
              r += partner.primaryContact.name ? partner.primaryContact.name + '\n' : '';
              r += partner.primaryContact.phoneNumber ? partner.primaryContact.phoneNumber + '\n' : '';
              r += partner.primaryContact.streetAddress1 ? partner.primaryContact.streetAddress1 + '\n' : '';
              r += partner.primaryContact.streetAddress2 ? partner.primaryContact.streetAddress2 + '\n' : '';
              r += partner.primaryContact.city ? partner.primaryContact.city + ', ' : '';
              r += partner.primaryContact.state ? partner.primaryContact.state + '\n' : '';
              r += partner.primaryContact.zip ? partner.primaryContact.zip + '\n' : '';
              r += partner.primaryContact.country ? partner.primaryContact.country + '\n' : '';
              if (r.length <= 0) {
                r = h + 'No information available \n';
              }
            }
          }

          return r;
        },

        findPartnerDiscount: function (categoryId) {
          var i,
            ii,
            r = null;

          for (i = 0, ii = this.templateDiscounts.length; i < ii; i++) {
            if (this.templateDiscounts[i].categoryId === categoryId) {
              r = this.templateDiscounts[i];
              break;
            }
          }

          return r;
        },

        findDiscount: function (id) {
          var i,
            ii,
            r = null;

          for (i = 0, ii = this.discounts.length; i < ii; i++) {
            if (this.discounts[i].id === id) {
              r = this.discounts[i];
              break;
            }
          }

          return r;
        },

        findPriceList: function (id) {
          var i,
            ii,
            r = null;

          for (i = 0, ii = this.priceLists.length; i < ii; i++) {
            if (this.priceLists[i].id === id) {
              r = this.priceLists[i];
              break;
            }
          }

          return r;
        },

        isOneTimeEvent: function () {
          return (
            (this.selectedEventStartHour && !this.selectedEventStartHour.id) ||
            (this.selectedEventStartHour &&
              this.selectedEventStartHour.type &&
              this.selectedEventStartHour.type === 'schedule')
          );
        },

        isCustomEvent: function () {
          return (
            (this.selectedEventStartHour && !this.selectedEventStartHour.id) ||
            (this.selectedEventStartHour &&
              this.selectedEventStartHour.type &&
              this.selectedEventStartHour.type !== 'schedule')
          );
        },

        hasDiscountedAddOns: function () {
          return (
            this.discountedAddOns &&
            this.discountedAddOns.inventoryAddOns instanceof Array &&
            this.discountedAddOns.inventoryAddOns.length > 0
          );
        },

        resetModel: function () {
          this.quantity = 0;
          this.total = 0;
        },

        resetEvents: function () {
          this.events = [
            {
              id: false,
              startDate: false,
              startHour: 'Custom Time',
              type: 'custom',
            },
          ];
          this.ticketExpirationSelection = this.ticketExpirationSetting[0];
        },

        resetPriceList: function () {
          var i, ii;

          if (this.discountedPriceList) {
            console.log('OrdersCreateController::resetPriceList -> this.discountedPriceList');

            if (this.discountedPriceList.prices instanceof Array) {
              for (i = 0, ii = this.discountedPriceList.prices.length; i < ii; i++) {
                console.log(
                  'OrdersCreateController::resetPriceList',
                  this.discountedPriceList.prices[i].discountedPrice
                );
                this.discountedPriceList.prices[i].discountedPrice = this.discountedPriceList.prices[i].price;
                this.discountedPriceList.prices[i].quantity = 0;
              }
            }
          } else {
            console.log('OrdersCreateController::resetPriceList -> !this.discountedPriceList');
          }
          if (this.hasDiscountedAddOns()) {
            console.log('OrdersCreateController::resetPriceList -> this.discountedAddOns');
            for (i = 0, ii = this.discountedAddOns.inventoryAddOns.length; i < ii; i++) {
              console.log(
                'OrdersCreateController::resetPriceList -> this.discountedAddOns',
                this.discountedAddOns.inventoryAddOns[i].price
              );
              this.discountedAddOns.inventoryAddOns[i].totalQuantity = 0;
            }
          } else {
            console.log('OrdersCreateController::resetPriceList -> !this.discountedAddOns');
          }
        },

        calculateTotal: function () {
          var i,
            ii,
            total = 0,
            quantity = 0,
            currentPrice = 0,
            addOnQuantity = 0;

          if (this.discountedPriceList) {
            console.log('OrdersCreateController::calculateTotal', this.discountedPriceList);

            if (this.discountedPriceList.prices instanceof Array) {
              for (i = 0, ii = this.discountedPriceList.prices.length; i < ii; i++) {
                if (this.discountedPriceList.prices[i].quantity >= 0) {
                  if (!this.toggleCSRPrices) {
                    if ($filter('saleChannel')([this.discountedPriceList.prices[i]], '!customerRep').length) {
                      //this item is hidden, set it's total quantity to 0;
                      this.discountedPriceList.prices[i].quantity = 0;
                    }
                  }
                  quantity += this.discountedPriceList.prices[i].quantity;
                  currentPrice = HelpersService.currencyFloatToInteger(
                    this.discountedPriceList.prices[i].discountedPrice
                  );
                  if (currentPrice >= 0) {
                    total += this.discountedPriceList.prices[i].quantity * currentPrice;
                  }
                }
              }
            } else {
              this.notice.showErrorMessages([
                {
                  message:
                    'No price list found. Please make sure your price list has the reseller sale channel enabled.',
                },
              ]);
            }
          }

          if (this.hasDiscountedAddOns()) {
            console.log('OrdersCreateController::calculateTotal', this.discountedAddOns.inventoryAddOns);
            for (i = 0, ii = this.discountedAddOns.inventoryAddOns.length; i < ii; i++) {
              if (this.discountedAddOns.inventoryAddOns[i].totalQuantity >= 0) {
                if (!this.toggleCSRAddons) {
                  if ($filter('saleChannel')([this.discountedAddOns.inventoryAddOns[i]], '!customerRep').length) {
                    //this item is hidden, set it's total quantity to 0;
                    this.discountedAddOns.inventoryAddOns[i].totalQuantity = 0;
                  }
                }
                addOnQuantity += this.discountedAddOns.inventoryAddOns[i].totalQuantity;
                currentPrice = HelpersService.currencyFloatToInteger(this.discountedAddOns.inventoryAddOns[i].price);
                if (currentPrice >= 0) {
                  total += this.discountedAddOns.inventoryAddOns[i].totalQuantity * currentPrice;
                }
              }
            }
          }

          this.addOnQuantity = addOnQuantity;
          this.quantity = quantity;
          this.total = HelpersService.integerToCurrencyFloat(total);
        },

        calculatePrice: function (category) {
          var price = category.discountedPrice * category.quantity;

          return price || 0;
        },

        calculateAddOnPrice: function (addon) {
          var price = addon.price * addon.totalQuantity;

          return price || 0;
        },

        togglePrices: function () {
          var self = $scope.ordersCreate;
          self.toggleCSRPrices = !self.toggleCSRPrices;
          self.calculateTotal();
        },

        toggleAddons: function () {
          var self = $scope.ordersCreate;
          self.toggleCSRAddons = !self.toggleCSRAddons;
          self.calculateTotal();
        },

        showTemplatesModal: function () {
          var self = $scope.ordersCreate;

          self.showModal = $uibModal.open({
            templateUrl: 'views/application/views/templates/modals/showTemplates.tpl.html',
            size: 'lg',
            controller: 'TemplatesShowModalController',
            resolve: {
              selectedTemplate: function () {
                return self.selectedEventTemplate;
              },
            },
          });

          self.showModal.result.then(
            function (template) {
              if (!template) {
                self.selectedEventTemplate = {
                  id: false,
                  name: 'Custom event...',
                };
              } else {
                self.selectedEventTemplate = template;
              }
            },
            function () {}
          );
        },

        migrate: function () {
          var i,
            ii,
            j,
            jj,
            d = CalendarService.toISO8601(this.eventDate),
            t = CalendarService.toISO8601(this.eventStartHour),
            schedule = {};

          this.template.startTime = d.replace(/(.*?T)\d{2}:\d{2}:\d{2}(.*$)/, '$100:00:00$2');

          if (!(this.template.schedules instanceof Array) || this.template.schedules.length <= 0) {
            this.template.schedules = [];
            this.template.schedules.push(TemplatesService.createSchedule(this.template.startTime));
          }

          if (this.template.ticketDetails) {
            this.template.ticketDetails = angular.extend(TemplatesService.createTicketDetails(), {
              ticketDurationDays: this.template.ticketDetails.ticketDurationDays,
              expireFromEventDate: this.ticketExpirationSelection.name === this.ticketExpirationSetting[0].name,
            });
          } else {
            this.template.ticketDetails = angular.extend(TemplatesService.createTicketDetails(), {
              expireFromEventDate: true,
            });
          }

          // because of the offschedule API we need to set this up
          this.template.id = this.selectedEventTemplate.id || false;

          if (this.template.id) {
            if (this.selectedEventStartHour && this.selectedEventStartHour.id) {
              if (this.selectedEventStartHour.type === 'event') {
                this.template.eventId = this.selectedEventStartHour.id;
                this.template.scheduleId = this.selectedEventStartHour.scheduleId;
                this.template.startTime = this.selectedEventStartHour.startTime;
                this.template.endTime = this.selectedEventStartHour.endTime;
                this.template.resources = this.selectedEventStartHour.resources || [];
              } else {
                this.template.scheduleId = this.selectedEventStartHour.id;
                this.template.startTime = moment(this.selectedEventStartHour.startTime).format();
                this.template.endTime = this.getEndTime(this.template.startTime, this.template.duration);

                if (this.selectedEventStartHour.schedule && this.selectedEventStartHour.schedule.resourceRequests) {
                  this.template.resources = this.processResourceRequests(
                    this.selectedEventStartHour.schedule.resourceRequests
                  );
                }

                if (this.selectedEventStartHour.schedule) {
                  this.template.salesChannels = this.selectedEventStartHour.schedule.salesChannels.map(function (item) {
                    if (item.name.toLowerCase() === 'web') {
                      item.enabled = false;
                    }
                    return item;
                  });
                }
              }
            } else {
              this.template.startTime = d.split('T')[0] + 'T' + t.split('T')[1];
              this.template.endTime = this.getEndTime(this.template.startTime, this.template.duration);
            }
          }

          if (this.partner && this.partner.company) {
            this.template.organization = this.partner.company;
          }

          this.template.images = [];
          // Do not change colorCategory

          this.template.schedules[0].days[0] = d.split('T')[0];
          this.template.schedules[0].effectiveStartTime = d.split('T')[0] + 'T' + t.split('T')[1];
          this.template.schedules[0].capacity = this.template.capacity;
          this.template.schedules[0].duration = this.template.duration;

          if (
            this.selectedEventStartHour &&
            this.selectedEventStartHour.id &&
            this.selectedEventStartHour.type === 'schedule'
          ) {
            schedule = angular.extend({}, this.selectedEventStartHour.schedule);
            this.template.schedules[0].hours = [this.selectedEventStartHour.hour];
          } else {
            this.template.schedules[0].hours[0].hour = parseInt(t.split('T')[1].split(':')[0], 10);
            this.template.schedules[0].hours[0].minutes = parseInt(t.split('T')[1].split(':')[1], 10);
            this.template.schedules[0].hours[0].quantity = 1;
          }

          if (this.isOneTimeEvent()) {
            this.template.schedules[0].honorHolidays = false;
            this.template.schedules[0].honorOpenHours = false;
          }

          if (this.hasDiscountedAddOns()) {
            this.template.addOns = angular.copy(this.discountedAddOns);
            for (i = 0, ii = this.template.addOns.inventoryAddOns.length; i < ii; i++) {
              this.template.addOns.inventoryAddOns[i].totalQuantity = null;
              this.template.addOns.inventoryAddOns[i].discountedPrice = null;
              delete this.template.addOns.inventoryAddOns[i].totalQuantity;
              delete this.template.addOns.inventoryAddOns[i].discountedPrice;
            }
          }

          if (this.discountedPriceList && this.discountedPriceList.hasOwnProperty('prices')) {
            if (!(this.template.priceLists instanceof Array) || this.template.priceLists.length <= 0) {
              this.template.priceLists = [];
              this.template.priceLists.push(this.discountedPriceList);
            } else {
              this.template.priceLists[0] = this.discountedPriceList;
            }
            this.clearSaleChannels(this.template.priceLists[0].prices);
          } else if (this.selectedPriceList) {
            if (!(this.template.priceLists instanceof Array) || this.template.priceLists.length <= 0) {
              this.template.priceLists = [];
              this.template.priceLists.push(this.selectedPriceList);
            } else {
              this.template.priceLists[0] = this.selectedPriceList;
            }
            this.clearSaleChannels(this.template.priceLists[0].prices);
          } else {
            this.notice.showErrorMessages([{ message: 'You must select a price list to create an order.' }]);
          }
        },

        clearSaleChannels: function (prices) {
          var i, ii, j, jj;
          // Clear sales channels
          console.log('OrdersCreateController::migrate', prices);
          for (i = 0, ii = prices.length; i < ii; i++) {
            for (j = 0, jj = prices[i].salesChannels.length; j < jj; j++) {
              if (
                prices[i].salesChannels[j].channel === 'manualEntry' ||
                prices[i].salesChannels[j].channel === 'customerRep' ||
                prices[i].salesChannels[j].channel === 'reseller'
              ) {
                prices[i].salesChannels[j].enabled = true;
              } else {
                prices[i].salesChannels[j].enabled = false;
              }
            }
          }
        },

        migrateDiscounts: function (eventTemplateId) {
          console.log('OrdersCreateController::migrateDiscounts', this.selectedDiscount);
          return [
            {
              eventTemplateId: eventTemplateId,
              categoryId: this.partner.accountCategoryRelation.categoryId,
              discountId: this.selectedDiscount && this.selectedDiscount.id ? this.selectedDiscount.id : null,
            },
          ];
        },

        hasSelectedStartHour: function () {
          return (
            this.selectedEventStartHour &&
            this.selectedEventStartHour.id &&
            this.selectedEventStartHour.type !== 'schedule'
          );
        },

        isValidExpireDays: function () {
          var r = true;

          if (this.isSubmitted || this.isValidated) {
            r = this.template.ticketDetails && this.template.ticketDetails.ticketDurationDays >= 0;
          }

          return r;
        },

        isValidStartHour: function () {
          var r = true;

          if (this.isSubmitted || this.isValidated) {
            r = this.selectedEventStartHour;
          }

          return r;
        },

        isValidName: function () {
          var r = true;

          if (this.isSubmitted || this.isValidated) {
            r = !!(this.template.name && this.template.name.length > 0);
          }

          return r;
        },

        isValidPriceList: function () {
          var r = true;

          if (this.isSubmitted || this.isValidated) {
            r = this.discountedPriceList.hasOwnProperty('prices');
          }

          return r;
        },

        isValidCapacity: function () {
          var r = true;

          if (this.isSubmitted || this.isValidated) {
            if (this.hasSelectedStartHour()) {
              r = parseInt(this.selectedEventStartHour.capacity, 10) > 0;
            } else {
              r = parseInt(this.template.capacity, 10) > 0;
            }
          }

          return r;
        },

        isValidQuantity: function () {
          var r = true;

          if (this.isSubmitted || this.isValidated) {
            r = this.quantity > 0;
          }

          return r;
        },

        isValidAvailability: function () {
          var r = true;

          if (this.isSubmitted || this.isValidated) {
            if (this.hasSelectedStartHour()) {
              r = +this.selectedEventStartHour.capacity - +this.selectedEventStartHour.soldQuantity >= this.quantity;
              console.log(
                'OrdersCreateController::isValidQuantity',
                this.selectedEventStartHour.capacity - this.selectedEventStartHour.soldQuantity
              );
            } else {
              r = +this.template.capacity >= this.quantity;
              console.log(
                'OrdersCreateController::isValidQuantity',
                this.template.capacity,
                this.quantity,
                this.quantity > 0 && +this.template.capacity >= this.quantity
              );
            }
          }

          return r;
        },

        validate: function () {
          var r = false;

          this.isValidated = true;

          if (
            this.isValidName() &&
            this.isValidPriceList() &&
            this.isValidStartHour() &&
            this.isValidCapacity() &&
            this.isValidAvailability() &&
            this.isValidQuantity() &&
            this.isValidExpireDays()
          ) {
            r = true;
          } else if (!this.isValidQuantity()) {
            this.notice.showErrorMessages([{ message: 'You must add tickets to the order.' }]);
          } else {
            this.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
          }

          return r;
        },

        createCustom: function () {
          this.selectedEventTemplate = {
            id: false,
            name: 'Custom event...',
          };
          this.resetEvents();
        },

        processResourceRequests: function (requests) {
          var r: TODO = false;

          if (requests instanceof Array) {
            r = requests.map(function (item) {
              return item.eventResource;
            });
          }

          return r;
        },

        complete: function () {
          var self = $scope.ordersCreate;

          this.isSubmitted = true;
          this.isValidated = false;

          if (this.validate()) {
            this.migrate();
            this.notice.hideSuccessMessages();
            this.notice.hideErrorMessages();

            // TODO: This needs to be based on whether or not an event instance has been selected
            if (this.selectedEventTemplate) {
              // Use the current template and update it if one has been selected
              if (this.accountId || this.customerId) {
                // if is from a existing template
                // if a private or a public schedule is selected
                if (this.selectedEventTemplate.id && this.selectedEventStartHour && this.selectedEventStartHour.id) {
                  // if its a private schedule
                  if (this.selectedEventStartHour.type === 'schedule') {
                    ApiService.event.createFromPrivateSchedule(this.template).then(function (response) {
                      var res = response;

                      // saving resources one by one
                      if (
                        self.selectedEventStartHour.schedule.hasOwnProperty('resourceRequests') &&
                        self.selectedEventStartHour.schedule.resourceRequests instanceof Array &&
                        self.selectedEventStartHour.schedule.resourceRequests.length
                      ) {
                        self.selectedEventStartHour.schedule.resourceRequests
                          .reduce(function (promise, item) {
                            return promise.then(function () {
                              return ApiService.program.resources.instance.create({
                                id: res.data.payload.id,
                                sendEmail: true,
                                resourceTimeFrame: item.resourceTimeFrame,
                                eventResource: item.eventResource,
                                notes: item.notes,
                              });
                            });
                          }, $q.when(null))
                          .then(
                            function () {
                              self.success.complete(res.data.payload);
                            },
                            function () {
                              self.error.complete({
                                data: {
                                  error: 'Resource requests could not been created.',
                                },
                              });
                            }
                          );
                      } else {
                        self.success.complete(res.data.payload);
                      }
                    }, self.error.complete);
                  } else {
                    // This means that existing instance has been selected
                    // We need to book against the instance and not create a new template
                    console.log('OrdersCreateController::complete', this.selectedEventStartHour);
                    this.success.complete(this.selectedEventStartHour);
                  }
                } else {
                  // no template selected
                  console.log('OrdersCreateController::complete', this.template);

                  if (!this.templateCreationInProgress) {
                    this.templateCreationInProgress = true;

                    // If no event start hour has been selected we need to create a new template
                    ApiService.program.create(this.template).then(function (response) {
                      var self = $scope.ordersCreate,
                        eventTemplateId = response.data.payload.id,
                        scheduleId = response.data.payload.schedules[0].id;

                      if (self.accountId) {
                        ApiService.partners.templates
                          .update({
                            eventTemplateId: eventTemplateId,
                            data: self.migrateDiscounts(eventTemplateId),
                          })
                          .then(function (response) {
                            // Template has been created now grab the only instance in the newly created template
                            var times = self.getEventTimes(),
                              data: TODO = {
                                accountId: self.accountId,
                                templateId: eventTemplateId,
                                startTime: CalendarService.toISO8601(times.startTime),
                                endTime: CalendarService.toISO8601(times.endTime),
                              };

                            if (self.customerId) {
                              data.customerId = self.customerId;
                            }

                            ApiService.partners.reseller.events(data).then(function (response) {
                              // Since we are always creating a new template with a single schedule
                              // We always want the first schedule in the list
                              if (response.data.payload && response.data.payload.length) {
                                self.success.complete(response.data.payload[0]);
                              } else {
                                //the event instance wasn't created - perhaps it was an event in the past?
                                self.error.complete({
                                  data: {
                                    error:
                                      'The event you requested could not be created. Please ensure the event date and time is in the future.',
                                  },
                                });
                              }
                            }, self.error.complete);
                          }, self.error.complete);
                      } else if (self.customerId) {
                        var times = self.getEventTimes();
                        ApiService.event.list(
                          {
                            page: -1,
                            pageSize: 1,
                            templateId: eventTemplateId,
                            startTime: CalendarService.toISO8601(times.startTime),
                            endTime: CalendarService.toISO8601(times.endTime),
                          },
                          function (response) {
                            self.success.complete(response.data.payload.list[0]);
                          },
                          self.error.complete
                        );
                      }
                    }, this.error.complete);
                  }
                }
              }
            }
          } else {
            this.isSubmitted = false;
          }
        },

        cancel: function () {
          if (this.accountId) {
            $state.go('application.partners.detail', { id: this.accountId });
          } else {
            $state.go('application.partners.list.default');
          }
        },

        isEventCSREnabled: function (salesChannels) {
          var r = true;
          salesChannels.forEach(function (salesChannel) {
            if (salesChannel.channel === 'customerRep') {
              r = salesChannel.enabled;
            }
          });
          return r;
        },

        processEvents: function (events) {
          var i,
            ii,
            _events: TODO[] = [];

          for (i = 0, ii = events.length; i < ii; i++) {
            if (events[i].salesChannels instanceof Array && events[i].salesChannels.length) {
              // include the events only if they are CSR enabled
              // and NOT off schedule (aka private Order Requests) - ENG-4293
              if (
                (!this.isCSR || this.isEventCSREnabled(events[i].salesChannels)) &&
                !events[i].offSchedule &&
                events[i].type === 'standard'
              ) {
                _events.push(this.processEvent(events[i]));
              }
            }
          }

          return _events;
        },

        processEvent: function (event) {
          event.startDate = $filter('date')(CalendarService.parseDate(event.startTime), $scope.ordersCreate.dateFormat);
          event.startHour = $filter('date')(CalendarService.parseDate(event.startTime), $scope.ordersCreate.hourFormat);
          event.type = 'event';

          return event;
        },

        getPrivateSchedulesEventTimes: function () {
          var self = $scope.ordersCreate,
            events: TODO[] = [];

          angular.forEach(self.currentTemplate.schedules, function (item, index) {
            if (item.type === 'private') {
              angular.forEach(item.hours, function (opening) {
                var date = new Date(self.eventDate);

                date.setHours(opening.hour);
                date.setMinutes(opening.minutes);
                date.setSeconds(0);
                date.setMilliseconds(0);

                events.push({
                  id: item.id,
                  startDate: $filter('date')(CalendarService.parseDate(date), $scope.ordersCreate.dateFormat),
                  startHour:
                    $filter('date')(CalendarService.parseDate(date), $scope.ordersCreate.hourFormat) + ' (private)',
                  startTime: CalendarService.parseDate(date),
                  hour: opening,
                  type: 'schedule',
                  schedule: item,
                });
              });
            }
          });

          return events;
        },

        success: {
          init: function (response) {
            var self = $scope.ordersCreate;

            self.eventTemplates = [
              {
                id: false,
                name: 'Custom event...',
              },
            ].concat(response.data.payload.list);
          },

          getPartners: function (response) {
            var self = $scope.ordersCreate;

            self.partner = response.data.payload;
            self.template.description = self.getPartnerDescription(self.partner);
          },

          getCustomer: function (response) {
            var self = $scope.ordersCreate,
              fullName: TODO[] = [];

            self.customer = response.data.payload;
            if (self.customer.prefix) {
              fullName.push(self.customer.prefix);
            }
            if (self.customer.firstName) {
              fullName.push(self.customer.firstName);
            }
            if (self.customer.middleName) {
              fullName.push(self.customer.middleName);
            }
            if (self.customer.lastName) {
              fullName.push(self.customer.lastName);
            }
            if (self.customer.suffix) {
              fullName.push(self.customer.suffix);
            }
            self.customer.fullName = fullName.join(' ');
          },

          getTemplate: function (response) {
            var self = $scope.ordersCreate;

            //if template is in draft state, flag it it as such.
            self.currentTemplate = response.data.payload;
            self.template.name = self.currentTemplate.name;

            if (self.currentTemplate.customFields !== undefined && self.currentTemplate.customFields !== null) {
              self.template.customFields = self.currentTemplate.customFields;
            }

            if (self.currentTemplate.GLCode !== undefined && self.currentTemplate.GLCode !== null) {
              self.template.GLCode = self.currentTemplate.GLCode;
            }

            if (self.currentTemplate.resources instanceof Array && self.currentTemplate.resources.length > 0) {
              self.template.resources = self.currentTemplate.resources;
            }

            self.template.description =
              HelpersService.strip(self.currentTemplate.description, 300) || self.currentTemplate.shortDescription;
            self.template.shortDescription = self.currentTemplate.shortDescription;

            if (self.currentTemplate.schedules instanceof Array && self.currentTemplate.schedules.length > 0) {
              self.template.capacity = self.currentTemplate.schedules[0].capacity;
              self.template.duration = self.currentTemplate.schedules[0].duration;
            }

            self.setTicketDetails();

            if (self.currentTemplate.emailConfirmationMessage) {
              self.template.emailConfirmationMessage = self.currentTemplate.emailConfirmationMessage;
            }

            if (self.currentTemplate.emailCancellationMessage) {
              self.template.emailCancellationMessage = self.currentTemplate.emailCancellationMessage;
            }

            if (self.currentTemplate.emailNotify) {
              self.template.emailNotify = angular.copy(self.currentTemplate.emailNotify);
            }

            if (self.currentTemplate.onlinePaymentsForOrgOrdersEmailNotify) {
              self.template.onlinePaymentsForOrgOrdersEmailNotify = angular.copy(self.currentTemplate.onlinePaymentsForOrgOrdersEmailNotify);
            }

            if (self.currentTemplate.colorCategory) {
              if (self.currentTemplate.colorCategory.backgroundColor && self.currentTemplate.colorCategory.textColor) {
                self.template.colorCategory = angular.copy(self.currentTemplate.colorCategory);
                self.spectrumConfig.color = self.currentTemplate.colorCategory.backgroundColor;
              }
            } else {
              self.template.colorCategory = angular.copy(TemplatesService.getColorCategory());
              self.spectrumConfig.color = TemplatesService.getColorCategory().backgroundColor;
            }

            if (self.currentTemplate.priceLists instanceof Array && self.currentTemplate.priceLists.length > 0) {
              self.selectedPriceList = self.findPriceList(self.currentTemplate.priceLists[0].id);
              self.discountedPriceList = self.currentTemplate.priceLists[0];
            } else {
              self.selectedPriceList = null;
            }
            //pick a pricelist if the template doesn't have it
            self.discountedAddOns =
              self.currentTemplate.hasOwnProperty('addOns') &&
              self.currentTemplate.addOns.inventoryAddOns instanceof Array
                ? self.currentTemplate.addOns
                : { inventoryAddOns: [] };
            self.getTemplateDiscounts(self.currentTemplate.id);

            self.getEvents(self.currentTemplate.id);

            console.log('OrdersCreateController::success::getTemplate', self.discountedAddOns);
          },

          getTemplateDiscounts: function (response) {
            var self = $scope.ordersCreate,
              discounts = response.data.payload;

            if (discounts instanceof Array && discounts.length > 0) {
              console.log('OrdersCreateController::getTemplateDiscounts -> templateDiscounts');
              self.templateDiscounts = discounts;
              $timeout(function () {
                self.getDiscountedPriceList();
              }, 100);
            } else {
              console.log('OrdersCreateController::getTemplateDiscounts -> reset');
              self.selectedDiscount = false;
              self.resetPriceList();
            }
          },

          getDiscountedPriceList: function (response) {
            var self = $scope.ordersCreate;

            if (self.discountedPriceList && self.discountedPriceList.hasOwnProperty('prices')) {
              self.discountedPriceList = angular.extend(self.discountedPriceList, response.data.payload);
            } else {
              self.discountedPriceList = response.data.payload;
            }

            self.calculateTotal();
          },

          getEvent: function (response) {
            var self = $scope.ordersCreate;

            self.event = response.data.payload;
            self.discountedPriceList = self.event.priceLists[0];
          },

          getEvents: function (response) {
            var self = $scope.ordersCreate;
            let events: TODO[] = [];
            let privateEvents: TODO = {};

            (events = []), (privateEvents = self.getPrivateSchedulesEventTimes());

            if (response.data && response.data.payload instanceof Array && response.data.payload.length > 0) {
              events = self.processEvents(response.data.payload);
            } else if (response.payload instanceof Array && response.payload.length > 0) {
              events = self.processEvents(response.payload);
            } else {
              // Default to nothing
              self.selectedEventStartHour = null;
            }

            self.events = [];
            self.events = privateEvents.concat(events);

            self.events.push({
              id: false,
              startDate: false,
              startHour: 'Custom Time',
              type: 'custom',
            });

            if (privateEvents.length) {
              self.selectedEventStartHour = self.events[0];
            }
          },

          getPriceLists: function (response) {
            $scope.ordersCreate.priceLists = response.data.payload.list;
          },

          getDiscounts: function (response) {
            var self = $scope.ordersCreate;
            self.discounts = response.data.payload.list;
          },

          // Unique in that it only accepts an event instance that may or may not have come from a newly created template
          complete: function (event) {
            var self = $scope.ordersCreate,
              stateParams: TODO = { id: event.id },
              data: TODO = {
                eventId: event.id,
                priceList: self.discountedPriceList,
                addOns: self.discountedAddOns,
                toggleCSRPrices: self.toggleCSRPrices,
                toggleCSRAddons: self.toggleCSRAddons,
              };

            if (self.accountId) {
              stateParams.accountId = data.accountId = self.accountId;
            }

            if (self.customerId) {
              stateParams.customerId = data.customerId = self.customerId;
            }

            OrderService.store(data);

            $state.go('application.orders.checkout', stateParams);
            console.log('OrdersCreateController::complete', 'application.orders.checkout', {
              customerId: self.customerId,
              accountId: self.accountId,
              id: event.id,
              csr: self.toggleCSRPrices,
              addons: self.toggleAddons,
            });

            $timeout(function () {
              self.isSubmitted = false;
              self.templateCreationInProgress = false;
            }, 100);
          },
        },

        error: {
          init: function (response) {},
          initSources: function (response) {},
          getPartners: function (response) {},
          getCustomer: function (response) {},
          getTemplateDiscounts: function (response) {
            $scope.ordersCreate.loadedTemplate = false;
          },
          getEvent: function (response) {},
          getEvents: function (response) {},
          getPriceLists: function (response) {},
          getDiscounts: function (response) {},
          complete: function (response) {
            $scope.ordersCreate.isSubmitted = false;
            $scope.ordersCreate.templateCreationInProgress = false;
            $scope.ordersCreate.notice.showErrorMessages([
              {
                message: response.data.error,
              },
            ]);
          },
        },

        onEventStartHourChange: function (n, o) {
          var self = $scope.ordersCreate;

          if (n && n.id) {
            if (n.type === 'schedule') {
              self.template.type = 'private';
              self.template.capacity = n.schedule.capacity;
              self.template.duration = n.schedule.duration;
              self.template.schedules[0].name = n.schedule.name;
              if (n.schedule.priceLists instanceof Array && n.schedule.priceLists.length) {
                self.discountedPriceList = n.schedule.priceLists[0];
              }
            } else {
              // Existing Event
              self.template.type = 'standard';
              self.discountedPriceList = n.priceList;
              // Save old selection of color codes
              self.disableColor = true;
              if (n.colorCategory.backgroundColor) {
                self.eventBackgroundColor = n.colorCategory.backgroundColor;
              }
              self.resetSchedule();
              console.log('OrdersCreateController::onEventStartHourChange -> n.id', n, self.discountedPriceList.id);
            }
          } else {
            // New Event Creation
            self.template.type = 'private';
            self.event = {};
            self.disableColor = false;
            self.eventBackgroundColor = TemplatesService.getColorCategory().backgroundColor;
            self.resetSchedule();
            console.log('OrdersCreateController::onEventStartHourChange -> !n.id', self.selectedEventTemplate);

            if (self.selectedEventTemplate && self.selectedEventTemplate.id) {
              if (self.currentTemplate.schedules instanceof Array && self.currentTemplate.schedules.length > 0) {
                self.template.capacity = self.currentTemplate.schedules[0].capacity;
                self.template.duration = self.currentTemplate.schedules[0].duration;
              }

              if (self.currentTemplate.priceLists instanceof Array && self.currentTemplate.priceLists.length > 0) {
                self.selectedPriceList = self.findPriceList(self.currentTemplate.priceLists[0].id);
                self.discountedPriceList = self.currentTemplate.priceLists[0];
              } else {
                self.selectedPriceList = null;
              }
            } else {
              //self.discountedPriceList = false;
            }
            // console.log('OrdersCreateController::onEventStartHourChange -> !n.id', self.discountedPriceList.id);
          }

          self.setTicketDetails();

          self.calculateTotal();
        },

        /*
         * Sets the ticket expiration duration (in days) from currently selected template
         * Also translates the expirationFromEventDate flag to the ticketExpirationSetting Enum for display
         */
        setTicketDetails: function () {
          if (this.currentTemplate && this.currentTemplate.ticketDetails) {
            this.template.ticketDetails.ticketDurationDays = this.currentTemplate.ticketDetails.ticketDurationDays;
            this.ticketExpirationSelection =
              this.currentTemplate.ticketDetails && this.currentTemplate.ticketDetails.expireFromEventDate
                ? this.ticketExpirationSetting[0]
                : this.ticketExpirationSetting[1];
          } else {
            this.template.ticketDetails.ticketDurationDays = 365;
            this.ticketExpirationSelection = this.ticketExpirationSetting[0];
          }
        },

        onTemplateDateChange: function (n, o) {
          var self = $scope.ordersCreate;
          if (self.selectedEventTemplate) {
            if (self.selectedEventTemplate.id) {
              self.getEvents(self.selectedEventTemplate.id);
            } else {
              self.resetEvents();
            }
          } else {
            self.resetEvents();
          }
          self.updateEventStartHour();
        },

        onTemplateDiscountsLoaded: function (n, o) {
          var self = $scope.ordersCreate;
          if (n) {
            if (
              self.selectedEventTemplate &&
              self.selectedEventTemplate.id &&
              self.partner &&
              self.partner.accountCategoryRelation
            ) {
              self.templateDiscount = self.findPartnerDiscount(self.partner.accountCategoryRelation.categoryId);
              if (self.templateDiscount) {
                self.selectedDiscount = self.findDiscount(self.templateDiscount.discountId);
              } else {
                self.selectedDiscount = false;
                self.resetPriceList();
              }
            }
            console.log(
              'OrdersCreateController::onTemplateDiscountsLoaded',
              self.templateDiscount,
              self.selectedDiscount
            );
          }
        },

        onSelectedDiscountUpdate: function (n, o) {
          var self = $scope.ordersCreate;
          if (n) {
            if (
              self.selectedEventTemplate &&
              self.selectedEventTemplate.id &&
              self.partner &&
              self.partner.accountCategoryRelation
            ) {
              self.templateDiscount = self.findPartnerDiscount(self.partner.accountCategoryRelation.categoryId);
              if (self.templateDiscount) {
                self.selectedDiscount = self.findDiscount(self.templateDiscount.discountId);
              } else {
                self.resetPriceList();
              }
            } else {
              if (self.selectedPriceList && self.selectedDiscount) {
                self.getDiscountedPriceList();
              } else {
                self.resetPriceList();
              }
            }

            console.log(
              'OrdersCreateController::onSelectedDiscountUpdate',
              self.templateDiscount,
              self.selectedDiscount
            );
          } else {
            self.resetPriceList();
            console.log('OrdersCreateController::onSelectedDiscountUpdate -> reset');
          }
          self.calculateTotal();
        },

        onEventTemplateChange: function (n, o) {
          var reset = false,
            self = $scope.ordersCreate;

          if (self.accountId || self.customerId) {
            self.notice.hideSuccessMessages();
            self.notice.hideErrorMessages();
          }

          self.isSubmitted = false;

          if (self.selectedEventTemplate) {
            if (self.selectedEventTemplate.id) {
              self.getTemplate(self.selectedEventTemplate.id);
              self.quantity = 0;
              self.total = 0;
            } else {
              reset = true;
            }
          } else {
            self.resetEvents();
            reset = true;
          }

          if (reset) {
            console.log('OrdersCreateController::onEventTemplateChange', reset);
            self.selectedPriceList = null;
            self.selectedDiscount = null;
            self.discountedPriceList = null;
            self.template.description = self.getPartnerDescription(self.partner);
            self.template.name = '';
            self.template.capacity = 0;
            self.template.colorCategory = TemplatesService.getColorCategory();
            self.spectrumConfig.color = TemplatesService.getColorCategory().backgroundColor;
          }
        },

        onPriceListChange: function (n, o) {
          var self = $scope.ordersCreate;

          // Only run if we are creating a custom event
          if (!self.selectedEventTemplate.id || !(self.currentTemplate.priceLists instanceof Array)) {
            self.discountedPriceList = angular.copy(self.selectedPriceList);
            // Set all discounts to prices because no discount has been selected
            if (self.discountedPriceList && !self.selectedDiscount) {
              console.log('OrdersCreateController::onPriceListChange -> reset');
              self.resetPriceList();
            } else {
              console.log('OrdersCreateController::onPriceListChange -> fetch');
              self.getDiscountedPriceList();
            }
            self.calculateTotal();
          }
        },

        onDateFormatLoad: function (e, data) {
          $scope.ordersCreate.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
          $scope.ordersCreate.hourFormat = UserPreferencesService.getHourFormat('standardTime', 'hourFormat');
        },

        onColorCodesUpdate: function (n, o) {
          if (n && n !== o) {
            $scope.ordersCreate.template.colorCategory = angular.copy(n);
          }
        },
      };

      $scope.ordersCreate.init();
    },
  ]).name;
